import { useState } from "react";
import { observer } from "mobx-react-lite";
import { Image } from "lucide-react";
import { useGetNoteFile } from "../useGetNoteFile";
import { ImagePreview } from "./ImagePreview";

export const NoteImage = observer(({ thumbnail, id }: Dryp.Note) => {
	const [isOpen, setIsOpen] = useState(false);
	const { fetchNoteFile, fileUrl, loading } = useGetNoteFile(id);

	const thumbnailSrc = thumbnail?.startsWith("data:") ? thumbnail : `data:image/jpeg;base64,${thumbnail}`;

	const handleClick = () => {
		setIsOpen(true);
		fetchNoteFile();
	};

	const handleClose = () => {
		setIsOpen(false);
	};

	if (!thumbnail) {
		return (
			<>
				<div
					className="w-16 h-16 rounded overflow-hidden border border-border bg-secondary flex items-center justify-center cursor-pointer hover:bg-secondary/80"
					onClick={handleClick}
				>
					<Image className="w-4 h-4 text-muted-foreground" />
				</div>
				{isOpen && <ImagePreview imageSrc={fileUrl} loading={loading} onClose={handleClose} />}
			</>
		);
	}

	return (
		<>
			<div
				className="w-16 h-16 rounded overflow-hidden border border-border bg-secondary cursor-pointer hover:opacity-80"
				onClick={handleClick}
			>
				<img src={thumbnailSrc} alt="" className="w-full h-full object-cover" loading="lazy" />
			</div>
			{isOpen && <ImagePreview imageSrc={fileUrl} loading={loading} onClose={handleClose} />}
		</>
	);
});
